import React from 'react';

const SuccessLogo = () => (
  <svg width="64px" height="61px" viewBox="0 0 64 61">
    <defs />
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Artboard-Copy-3"
        transform="translate(-318.000000, -320.000000)"
        fill="#15CD72"
      >
        <g id="Page-1" transform="translate(318.000000, 320.000000)">
          <path
            d="M32.5756478,38.0224091 L63.1840089,7.52240909 C64.271997,6.43827273 64.271997,4.68590909 63.1840089,3.60177273 C62.0960208,2.51763636 60.3374313,2.51763636 59.2494432,3.60177273 L30.6083649,32.1414545 L24.2279129,25.7835909 C23.1399248,24.6994545 21.3813353,24.6994545 20.2933472,25.7835909 C19.2053591,26.8677273 19.2053591,28.6200909 20.2933472,29.7042273 L28.6410821,38.0224091 C29.1836849,38.5630909 29.8960249,38.8348182 30.6083649,38.8348182 C31.320705,38.8348182 32.033045,38.5630909 32.5756478,38.0224091 M30.6083649,61 L30.5916695,61 C13.7153322,60.9916818 -0.0083439286,47.3027273 3.80625527e-06,30.4833636 C0.00835154111,13.6723182 13.7403754,0 30.6083649,0 L30.6250604,0 C34.9408393,0.00277272727 39.1258371,0.890045455 43.0659679,2.63963636 C44.4683874,3.2635 45.1000326,4.90218182 44.4739525,6.30240909 C43.8478724,7.69986364 42.2033687,8.32372727 40.8009492,7.70540909 C37.575941,6.27468182 34.1533697,5.54822727 30.6222778,5.54545455 L30.6083649,5.54545455 C16.8067766,5.54545455 5.57072553,16.7306364 5.56516038,30.4861364 C5.55959522,44.2471818 16.784516,55.449 30.594452,55.4545455 L30.6083649,55.4545455 C37.292118,55.4545455 43.5779623,52.8648182 48.3055628,48.1567273 C53.0387285,43.4458636 55.6487869,37.1795 55.6515695,30.5138636 L55.6515695,27.938 C55.6515695,26.4074545 56.8981646,25.1652727 58.4341478,25.1652727 C59.970131,25.1652727 61.2167261,26.4074545 61.2167261,27.938 L61.2167261,30.5166364 C61.2139435,38.6656818 58.0251088,46.3239545 52.2401285,52.0801364 C46.4607134,57.8335455 38.7780148,61 30.6083649,61"
            id="Fill-1"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SuccessLogo;



// WEBPACK FOOTER //
// ./src/components/logo.js